import ssUtil from "servicestack/util";
import resolve from "ioc/resolve";
// import EW from "servicestack/eventsource";
import $appConfig from "servicestack/config";
import angular from "angular";

//angular ioc
const $http = resolve("$http");
//const $rootScope = resolve('$rootScope');
const $q = resolve("$q");

export class EventListener {
  constructor() {
    const $el = this;
    $el.reconnects = 0;
    $el.options = {};
    $el.source = {};
    // $el.getEventSource(); TODO: here

    // register listeners
    window.addEventListener("beforeunload", () => {
      $el.dispose();
    });
  }

  getEventSource() {
    const $el = this;
    console.debug("getEventSource", $el);
    let src = new window.EventSource(
      $appConfig.serviceUrl +
        "event-stream?reconnects=" +
        $el.reconnects++ +
        "&channel=&t=" +
        new Date().getTime()
    );
    src.onmessage = (e) => $el.messageRecieved(e);
    $el.source && $el.source.close && $el.source.close();
    return ($el.source = src);
  }

  messageRecieved(e) {
    const $el = this;
    const $rootScope = resolve("$rootScope");
    let parts = ssUtil.splitOnFirst(e.data, " ");
    let selector = parts[0];
    let selParts = ssUtil.splitOnFirst(selector, "@");
    if (selParts.length > 1) {
      e.channel = selParts[0];
      selector = selParts[1];
    }
    let json = parts[1];
    let msg = json ? JSON.parse(json) : null;
    let cmdName =
      selector.indexOf("cmd.") === 0
        ? (selector = ssUtil.splitOnFirst(selector, ".")[1])
        : selector;
    let fn = $el[cmdName];
    fn && fn.call && fn.call($el, e, msg);
    $rootScope.$broadcast(selector, msg);
    console.debug("messageRecieved", selector, {
      cmdName,
      selector,
      msg,
      $el,
      e,
    });
    cmdName !== selector && $rootScope.$broadcast(cmdName, msg);
  }

  onConnect(ev, cn) {
    const $el = this;
    const opt = angular.extend($el.options, cn);
    // console.debug("onConnect", { $el, ev, cn, opt });
    if (opt.heartbeatUrl) {
      if (opt.heartbeat) {
        window.clearTimeout(opt.heartbeat);
      }
      opt.heartbeat = $el.pulse();
    }
  }

  dispose() {
    const $el = this;
    let result = true;
    if ($el.options.unRegisterUrl) {
      result = $http.post($el.options.unRegisterUrl, null);
    }
    $el.source && $el.source.close && $el.source.close();
    return $q.when(result);
  }

  pulse() {
    const $el = this;
    return window.setTimeout(function () {
      let req = {
        url: $el.options.heartbeatUrl,
        timeout: 8000,
      };
      $http(req).then(
        () => $el.pulseSuccess(),
        () => $el.pulseError()
      );
    }, parseInt($el.options.heartbeatIntervalMs) || 10000);
  }

  pulseSuccess() {
    const $el = this;
    $el.options.heartbeat = $el.pulse();
  }

  pulseError() {
    const $el = this;
    $el
      .dispose()
      .then(
        () => console.log("disposed!", $el),
        () => console.warn("dispose failed", arguments)
      )
      .finally(() => $el.getEventSource());
  }
}

export default new EventListener();
